import { useNavigate } from "@tanstack/react-router";

import { useHotelDataContext } from "@/features/hotels/contexts/HotelDataContext";
import type { HotelData } from "@/features/hotels/types/types";
import { rudderAnalytics, HotelTrackingEvents } from "@/lib/rudderstack";

export const useOnHotelOfferClick = () => {
  const navigate = useNavigate();
  const { setData: setHotelData } = useHotelDataContext();

  const handleOfferClick = (hotel: HotelData) => {
    rudderAnalytics.track(HotelTrackingEvents.USER_ENTERED_PARTICULAR_OFFER, {
      offer_id: hotel.id,
      offer_type: "Hotel",
      price: hotel.minPrice?.value,
    });
    setHotelData(hotel);
    navigate({
      to: "/hotels/$id/details",
      params: { id: hotel.id },
    });
  };

  return handleOfferClick;
};
